exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-26b51288] .el-calendar-table .el-calendar-day {\n  font-size: 20px;\n  text-align: center;\n  height: 65px;\n  background: lightgrey;\n}\n.mark[data-v-26b51288] {\n  font-size: 15px;\n  color: white;\n  background: #e74b4b;\n  height: 33px;\n  overflow: hidden;\n  line-height: 33px;\n  word-break: break-word;\n}\n", ""]);

// exports
